import Vue from "vue";
import App from "./App.vue";
import VueGlobalVar from "vue-global-var";
import vuetify from "./plugins/vuetify";
import router from "./router";
import "./styles.sass";
import VueExpandableImage from "vue-expandable-image";
import EventBus from "./event-bus";
import axios from "axios";
import VCurrencyField from "v-currency-field";
import { VTextField } from "vuetify/lib";

Vue.config.productionTip = false;

Vue.use(VueExpandableImage);

Vue.prototype.$bus = EventBus;

Vue.component("v-text-field", VTextField);
Vue.use(VCurrencyField, {
  locale: "id-ID",
  decimalLength: 0,
  autoDecimalMode: false,
  min: null,
  max: null,
  defaultValue: 0,
  valueAsInteger: true,
  allowNegative: false,
});

Vue.use(VueGlobalVar, {
  globals: {
    $api: "https://api-ppdb.smkruskudus.com/api/v2",
    $storage: "https://api-ppdb.smkruskudus.com/storage",
    $date: [
      {
        open: "2026-10-01",
        close: "2026-12-31",
        test: "2027-01-02",
        result: "2027-01-11",
        daftarUlang: "12 - 19 Januari 2027",
        wave: 1,
      },
      {
        open: "2027-01-22",
        close: "2027-04-08",
        test: "2027-04-10",
        result: "2027-04-19",
        daftarUlang: "20 - 27 April 2027",
        wave: 2,
      },
      {
        open: "2030-06-12",
        close: "2030-06-17",
        test: "2030-06-19",
        result: "2030-06-23",
        daftarUlang: "-",
        wave: 3,
      },
      {
        open: "2040-07-01",
        close: "2040-07-01",
        test: "2040-07-01",
        result: "2040-07-01",
        daftarUlang: "-",
        wave: 4,
      },
    ],
  },
});

Vue.mixin({
  mounted() {
    axios.defaults.headers.common = {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    };
  },
});

new Vue({
  vuetify,
  router,
  render: (h) => h(App),
}).$mount("#app");
